import {
  Box,
  Grid,
  TextField,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Avatar,
  ButtonGroup,
  Checkbox,
} from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
import {
  DataGrid,
  GridFooter,
  gridColumnPositionsSelector,
  gridVisibleColumnDefinitionsSelector,
  gridFilteredSortedRowEntriesSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { useState, useEffect, useCallback, useMemo } from "react";
import BlockIcon from "@mui/icons-material/Block";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AppBreadcrumbs from "./../../components/AppBreadcrumbs";
import toast, { Toaster } from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import * as services from "../../services/saleng";
import NoPhotographyOutlinedIcon from "@mui/icons-material/NoPhotographyOutlined";
import { formatNumber } from "./../../utils/formatNumber";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import "moment/locale/th";
import { getSaleOrderPricing, calculateSpecialPrice, getLockSellProductId } from "../../utils/lockPricing";
import SellProductDialog from "./SellProductDialog";

const LockPricingFooter = () => {
  const apiRef = useGridApiContext();
  const rows = useGridSelector(apiRef, gridFilteredSortedRowEntriesSelector);
  const columns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);
  const positions = useGridSelector(apiRef, gridColumnPositionsSelector);
  const [scrollLeft, setScrollLeft] = useState(0);
  const columnIndex = columns.findIndex((column) => column.field === "lockWeightBalance");

  useEffect(() => {
    setScrollLeft(apiRef.current.getScrollPosition().left);
    return apiRef.current.subscribeEvent("scrollPositionChange", ({ left }) => {
      setScrollLeft(left);
    });
  }, [apiRef]);
  const totals = rows.reduce(
    (sum, { model }) => {
      const weight = Number(model.weight ?? 0);
      const remainingWeight = Number(model.remainingWeight ?? weight);
      sum.weight += weight;
      sum.soldWeight += Math.max(0, weight - remainingWeight);
      return sum;
    },
    { weight: 0, soldWeight: 0 },
  );

  return (
    <Box>
      {columnIndex !== -1 && <Box
        sx={{
          position: "relative",
          height: 48,
          overflow: "hidden",
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <Typography
          fontWeight={700}
          aria-label="รวม น้ำหนักขายจริง/น้ำหนัก Lock (กก.)"
          sx={{
            position: "absolute",
            left: positions[columnIndex] - scrollLeft,
            width: columns[columnIndex].computedWidth,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#c6dad7",
            whiteSpace: "nowrap",
          }}
        >
          รวม {formatNumber(totals.soldWeight)} / {formatNumber(totals.weight)}
        </Typography>
      </Box>}
      <GridFooter />
    </Box>
  );
};

const GroupPricingPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const initialMasterId = Number(searchParams.get("masterId")) || null;
  const initialCustomerId = Number(searchParams.get("customerId")) || null;
  const isDetailPage = Boolean(initialMasterId);
  const [loading, setLoading] = useState(true);
  const [shopId, setShopId] = useState(null);
  const [rowModesModel, setRowModesModel] = useState({});
  const [customers, setCustomers] = useState([]);

  const [masterStatus, setMasterStatus] = useState("all");
  const [startDate, setStartDate] = useState("");

  const [selectedUserId, setSelectedUserId] = useState(initialCustomerId);
  const [products, setProducts] = useState([]);
  const [masters, setMasters] = useState([]);
  const [showManualRows, setShowManualRows] = useState(true);
  const [selectedMasterId, setSelectedMasterId] = useState(initialMasterId);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingMasters, setLoadingMasters] = useState(false);
  const [shop, setShop] = useState(null);
  const [sellProductRow, setSellProductRow] = useState(null);
  const [refreshVersion, setRefreshVersion] = useState(0);
  const [stockConfirmMaster, setStockConfirmMaster] = useState(null);
  const [stockTargetStatus, setStockTargetStatus] = useState("APPROVED");
  const [approvingMaster, setApprovingMaster] = useState(false);

  const currentBranchId = String(localStorage.getItem("branchId") || "");
  const canSelectBranchCustomers = Boolean(
    String(shop?.shopType || "").toUpperCase() === "FRANCHISE" &&
      shop?.branches?.some(
        (branch) =>
          String(branch.id) === currentBranchId && branch.branchCode === "B01",
      ),
  );
  const currentBranch = shop?.branches?.find(
    (branch) => String(branch.id) === currentBranchId,
  );
  const currentBranchCode = String(
    currentBranch?.branchCode || localStorage.getItem("branchCode") || "",
  ).toUpperCase();
  const showPinkColumns = currentBranchCode === "B01";
  const onlyApprovedMasters = currentBranchCode === "B01";
  const canEditSellProduct =
    Boolean(currentBranch) && !["B01", "B1"].includes(currentBranchCode);

  // const filteredUsers = customers.filter((u) =>
  //   u.name.toLowerCase().includes(userSearch.toLowerCase())
  // );

  // const filteredProducts = products.filter(
  //   (p) =>
  //     // p.title.toLowerCase().includes(productSearch.toLowerCase()) ||
  //     p.category.includes(productSearch) ||
  //     p.subCategory.includes(productSearch)
  // );

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        if (decoded.id) {
          setShopId(decoded.id);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  // โหลดข้อมูล Shop เพื่อกำหนดสิทธิ์การเลือกลูกค้า
  useEffect(() => {
    let active = true;
    services
      .getShop()
      .then((res) => {
        if (active) setShop(res?.data?.data || null);
      })
      .catch((err) => {
        console.error("โหลดข้อมูล Shop ไม่สำเร็จ:", err);
        if (active) setShop(null);
      });

    return () => {
      active = false;
    };
  }, []);

  // แสดงลูกค้าเฉพาะ Shop Franchise ที่สาขาปัจจุบันเป็น B01
  useEffect(() => {
    if (!shop) return;

    if (!canSelectBranchCustomers) {
      setCustomers([]);
      setSelectedUserId(null);
      setProducts([]);
      setMasters([]);
      setSelectedMasterId(null);
      return;
    }

    let active = true;
    const fetchUsers = async () => {
      setLoadingUsers(true);
      try {
        const res = await services.getCustomers();
        const branchCustomers = (res?.data?.data || []).filter(
          (customer) =>
            String(customer.customerKind || "").toUpperCase() === "BRANCH",
        );
        if (active) setCustomers(branchCustomers);
      } catch (err) {
        console.error("โหลดรายชื่อลูกค้าสาขาไม่สำเร็จ:", err);
        if (active) setCustomers([]);
        toast.error("โหลดรายชื่อลูกค้าสาขาไม่สำเร็จ");
      } finally {
        if (active) setLoadingUsers(false);
      }
    };
    fetchUsers();

    return () => {
      active = false;
    };
  }, [canSelectBranchCustomers, shop]);

  // โหลดสินค้าเมื่อเลือก user
  useEffect(() => {
    const fetchProducts = async () => {
      if (!shop || (canSelectBranchCustomers && !selectedUserId)) {
        setProducts([]);
        setMasters([]);
        setSelectedMasterId(null);
        return;
      }

      setLoadingProducts(true);
      setLoadingMasters(true);
      try {
        const includeClosed = Boolean(initialMasterId);
        const lockRequests = canSelectBranchCustomers
          ? [
              services.getLockPricingByCustomer(selectedUserId, initialMasterId, includeClosed),
              services.getLockPricingMastersByCustomer(selectedUserId),
            ]
          : [
              services.getLockPricingByBranch(currentBranchId, shop.id, includeClosed),
              services.getLockPricingMastersByBranch(currentBranchId, shop.id),
            ];
        const [res, masterRes, saleOrderRes, inventoryRes, purchaseOrderRes] =
          await Promise.all([
          ...lockRequests,
          services.getSaleOrders({ shopId: shop.id }).catch((error) => {
            console.error("โหลด Sale Order สำหรับราคาเริ่มต้นไม่สำเร็จ:", error);
            return { data: { data: [] } };
          }),
          services.getInventory().catch((error) => {
            console.error("โหลดน้ำหนักสินค้าในคลังไม่สำเร็จ:", error);
            return { data: { data: [] } };
          }),
          services
            .getPurchaseOrders({ shopId: shop.id, status: "open" })
            .catch((error) => {
              console.error("โหลดน้ำหนักคงเหลือจาก PO ไม่สำเร็จ:", error);
              return [];
            }),
        ]);
        const result = res?.data || {};
        const lockRows = Array.isArray(result) ? result : result.data || [];
        const masterResult = masterRes?.data || {};
        const masterRows = Array.isArray(masterResult)
          ? masterResult
          : masterResult.data || [];
        const saleOrderResult = saleOrderRes?.data || {};
        const saleOrders = Array.isArray(saleOrderResult)
          ? saleOrderResult
          : saleOrderResult.data || [];
        const inventoryResult = inventoryRes?.data || {};
        const inventoryRows = Array.isArray(inventoryResult)
          ? inventoryResult
          : inventoryResult.data || [];
        const inventoryWeightByProduct = new Map(
          inventoryRows.map((inventory) => [
            Number(inventory.productId),
            Number(inventory.quantity || 0),
          ]),
        );
        const purchaseOrders = Array.isArray(purchaseOrderRes)
          ? purchaseOrderRes
          : purchaseOrderRes?.data || [];
        const poRemainingWeightByProduct = new Map();
        purchaseOrders
          .filter(
            (purchaseOrder) =>
              String(purchaseOrder.status || "").toLowerCase() !== "close",
          )
          .forEach((purchaseOrder) => {
            (purchaseOrder.items || []).forEach((purchaseOrderItem) => {
              if (purchaseOrderItem.deletedAt != null) return;
              const remaining = purchaseOrderItem.unlimitedWeight
                ? 0
                : Math.max(
                    0,
                    Number(purchaseOrderItem.poWeight || 0) -
                      Number(purchaseOrderItem.actualWeight || 0),
                  );
              const productId = Number(purchaseOrderItem.productId);
              poRemainingWeightByProduct.set(
                productId,
                (poRemainingWeightByProduct.get(productId) || 0) + remaining,
              );
            });
          });
        const { prices: saleOrderPriceByProduct, weights: saleOrderWeightByProduct } =
          getSaleOrderPricing(saleOrders, shop.id);

        const mappedData = lockRows.map((item) => {
          const sellProductId = getLockSellProductId(item);
          const sorShopPrice = item.sorShopPrice ?? item.headOfficePrice;
          const seeContractProfit = Number(item.seeContractProfit ?? 1.5);
          const costPrice =
            sorShopPrice != null
              ? Number(sorShopPrice) + seeContractProfit
              : item.costPrice;
          const saleOrderPrice = saleOrderPriceByProduct.get(sellProductId);
          const autoSalePrice = saleOrderPrice ?? 0;
          const autoSalePriceSource = saleOrderPrice != null ? "SO" : "NO_SO";
          const salePriceIsAuto = item.salePrice == null;
          const salePriceSource = salePriceIsAuto
            ? autoSalePriceSource
            : "MANUAL";
          const salePrice = salePriceIsAuto
            ? autoSalePrice == null
              ? null
              : Number(autoSalePrice)
            : Number(item.salePrice);
          const stockQuota =
            (saleOrderWeightByProduct.get(sellProductId) || 0) -
            ((inventoryWeightByProduct.get(sellProductId) || 0) +
              (poRemainingWeightByProduct.get(sellProductId) || 0));
          const incentive = Number(item.incentive ?? 40);
          const remainingProfit =
            salePrice != null && costPrice != null
              ? salePrice - Number(costPrice)
              : null;
          const specialRatio =
            remainingProfit != null && incentive != null
              ? (remainingProfit * incentive) / 100
              : null;
          const specialPrice = calculateSpecialPrice(costPrice, salePrice, incentive);
          const purchaseQuantity =
            item.purchaseQuantity ?? item.weight;
          const seeShopPrice = item.seeShopPrice ?? item.branchPrice;
          const sorPayAmount =
            specialPrice != null && purchaseQuantity != null
              ? specialPrice * Number(purchaseQuantity)
              : null;
          const seeProfit =
            specialPrice != null && seeShopPrice != null
              ? specialPrice - Number(seeShopPrice)
              : null;
          const sorProfit =
            salePrice != null && specialPrice != null
              ? salePrice - specialPrice
              : null;
          const totalProfit =
            seeProfit != null && sorProfit != null
              ? seeProfit + sorProfit
              : null;
          const seeProfitRatio =
            totalProfit != null && totalProfit !== 0
              ? (seeProfit / totalProfit) * 100
              : null;
          const sorProfitRatio =
            totalProfit != null && totalProfit !== 0
              ? (sorProfit / totalProfit) * 100
              : null;

          return {
            ...item,
            id: item.id,
            productId: item.productId,
            status: item.status,
            recordDate: item.recordDate,
            weight: item.weight,
            remainingWeight: item.remainingWeight,
            branchPrice: item.branchPrice,
            headOfficePrice: item.headOfficePrice,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
            category: item.product?.category?.name || "",
            product: item.product?.title || "",
            unit: "กก.",
            // ชื่อฟิลด์ด้านล่างรองรับข้อมูลจาก pricing service หากมีการส่งมา
            // และจะแสดงเป็น "-" เมื่อ LockPricing รุ่นปัจจุบันยังไม่มีข้อมูลนั้น
            productName: item.productName || item.product?.title,
            sellProduct:
              item.sellProduct?.title || item.sellProductName || item.product?.title,
            purchaseQuantity,
            seeShopPrice,
            sorShopPrice,
            seeContractProfit,
            costPrice,
            salePrice,
            autoSalePrice,
            autoSalePriceSource,
            salePriceIsAuto,
            salePriceSource,
            stockQuota,
            remainingProfit,
            incentive,
            specialRatio,
            specialPrice,
            sorPayAmount,
            seeProfit,
            seeProfitRatio,
            sorProfit,
            sorProfitRatio,
          };
        });

        // สมมติมี setProducts เพื่อเก็บข้อมูล
        setProducts(mappedData);
        setMasters(masterRows);
        if (initialMasterId) {
          const requestedMaster = masterRows.find(
            (master) =>
              Number(master.id) === initialMasterId &&
              (!onlyApprovedMasters || master.status === "APPROVED"),
          );
          setSelectedMasterId(requestedMaster?.id || null);
          setStartDate(
            requestedMaster?.recordDate
              ? moment(requestedMaster.recordDate).format("YYYY-MM-DD")
              : "",
          );
        }
      } catch (error) {
        console.error("Error fetching lock-pricing:", error);
        setMasters([]);
        // ถ้ามี toast
        // toast.error("โหลดข้อมูลไม่สำเร็จ");
      } finally {
        setLoadingProducts(false);
        setLoadingMasters(false);
      }
    };

    fetchProducts();
  }, [
    canSelectBranchCustomers,
    currentBranch?.branchCode,
    currentBranchId,
    initialMasterId,
    refreshVersion,
    onlyApprovedMasters,
    selectedUserId,
    shop,
  ]);

  const filteredProducts = useMemo(() => {
    const selectedDate = startDate || null;

    return products.filter((product) => {
      if (selectedDate) {
        if (!product.recordDate) return false;
        const recordDate = new Date(product.recordDate);
        if (Number.isNaN(recordDate.getTime())) return false;
        const recordDateKey = moment(recordDate).format("YYYY-MM-DD");
        if (recordDateKey !== selectedDate) return false;
      }
      if (!showManualRows && (product.sellProductId != null || product.sourceLockId != null)) {
        return false;
      }
      return true;
    });
  }, [products, startDate, showManualRows]);

  // const fetchData = useCallback(async () => {
  //   // const res = await services.getProducts(shopId);
  //   // const products = res.data.data;

  //   // const adjRes = await services.getProductGroupsAdjustments(id);
  //   // const adjustments = adjRes.data.data;

  //   const userRes = await services.getCustomers();
  //   const users = userRes.data.data;

  //   console.log("users", users);

  //   // const productsWithIndex = products.map((item, index) => {
  //   //   const adjItem = adjustments.find((a) => a.productId === item.id);
  //   //   const adjustment = adjItem?.adjustment ?? 0;
  //   //   return {
  //   //     ...item,
  //   //     no: index + 1,
  //   //     category: item.category.name,
  //   //     subCategory: item.subCategory.name,
  //   //     adjustment,
  //   //     total: (item.price ?? 0) + adjustment,
  //   //     adjItem: !!adjItem,
  //   //   };
  //   // });

  //   // setProducts(productsWithIndex);
  //   setCustomers(users);
  //   setLoading(false);
  // }, []);

  // useEffect(() => {
  //   if (shopId) fetchData();
  // }, [fetchData, shopId]);

  const processRowUpdate = async (newRow, oldRow) => {
    if (oldRow.status === "CLOSED") {
      throw new Error("ไม่สามารถแก้ไขรายการที่สิ้นสุดแล้วได้");
    }
    const seeContractProfit =
      newRow.seeContractProfit == null || newRow.seeContractProfit === ""
        ? 1.5
        : Number(newRow.seeContractProfit);
    const salePriceInput =
      newRow.salePrice == null || newRow.salePrice === ""
        ? null
        : Number(newRow.salePrice);
    const salePriceWasEdited = newRow.salePrice !== oldRow.salePrice;
    const salePriceIsAuto = salePriceWasEdited
      ? salePriceInput == null
      : Boolean(newRow.salePriceIsAuto);
    const salePriceSource = salePriceIsAuto
      ? newRow.autoSalePriceSource
      : "MANUAL";
    const salePrice = salePriceIsAuto
      ? newRow.autoSalePrice == null
        ? null
        : Number(newRow.autoSalePrice)
      : salePriceInput;
    const persistedSalePrice = salePriceIsAuto ? null : salePrice;
    const incentive =
      newRow.incentive == null || newRow.incentive === ""
        ? 40
        : Number(newRow.incentive);
    if (
      !Number.isFinite(seeContractProfit) ||
      (salePrice !== null && !Number.isFinite(salePrice)) ||
      (incentive !== null &&
        (!Number.isFinite(incentive) || incentive < 0 || incentive > 100))
    ) {
      throw new Error("Incentive ต้องอยู่ระหว่าง 0 ถึง 100 เปอร์เซ็นต์");
    }
    const sorShopPrice = Number(newRow.sorShopPrice ?? newRow.headOfficePrice ?? 0);
    const costPrice = sorShopPrice + seeContractProfit;
    const remainingProfit =
      salePrice == null ? null : salePrice - costPrice;
    const specialRatio =
      remainingProfit == null || incentive == null
        ? null
        : (remainingProfit * incentive) / 100;
    const specialPrice = calculateSpecialPrice(costPrice, salePrice, incentive);
    const purchaseQuantity = Number(newRow.purchaseQuantity ?? newRow.weight ?? 0);
    const seeShopPrice = Number(newRow.seeShopPrice ?? newRow.branchPrice ?? 0);
    const sorPayAmount =
      specialPrice == null ? null : specialPrice * purchaseQuantity;
    const seeProfit =
      specialPrice == null ? null : specialPrice - seeShopPrice;
    const sorProfit =
      salePrice == null || specialPrice == null
        ? null
        : salePrice - specialPrice;
    const totalProfit =
      seeProfit == null || sorProfit == null ? null : seeProfit + sorProfit;
    const seeProfitRatio =
      totalProfit == null || totalProfit === 0
        ? null
        : (seeProfit / totalProfit) * 100;
    const sorProfitRatio =
      totalProfit == null || totalProfit === 0
        ? null
        : (sorProfit / totalProfit) * 100;
    try {
      await services.updateLockPricingContractProfit(newRow.id, {
        seeContractProfit,
        salePrice: persistedSalePrice,
        incentive,
      });
      const updatedRow = {
        ...newRow,
        seeContractProfit,
        salePrice,
        salePriceIsAuto,
        salePriceSource,
        incentive,
        costPrice,
        remainingProfit,
        specialRatio,
        specialPrice,
        sorPayAmount,
        seeProfit,
        seeProfitRatio,
        sorProfit,
        sorProfitRatio,
      };
      setProducts((prev) =>
        prev.map((p) => (p.id === newRow.id ? { ...p, ...updatedRow } : p)),
      );
      toast.success("อัปเดตราคาสำเร็จแล้ว");
      return updatedRow;
    } catch (error) {
      console.error("Error updating row:", error);
      toast.error("เกิดข้อผิดพลาดในการอัปเดตราคา");
      return oldRow;
    }
  };

  const header = (label) => (
    <Box sx={{ whiteSpace: "normal", lineHeight: 1.15, textAlign: "center", fontWeight: 700 }}>
      {label}
    </Box>
  );
  const columnLabels = {
    seeContractProfit: "กำไร See ตามสัญญา",
    costPrice: "ราคาซื้อ (ต้นทุน) (ราคา+1.5แล้ว)",
    salePrice: "ราคาขาย",
    stockQuota: "Stock (โควต้าซื้อ-ขาย)",
    remainingProfit: "กำไรที่เหลือ (บาท)",
    incentive: "Incentive (ปรับแก้ได้)",
    specialRatio: "สัดส่วน+พิเศษ (บาท)",
    specialPrice: "ราคาพิเศษ ++",
    sorPayAmount: "จำนวนเงินที่ Sor ต้องจ่ายเมื่อรับสินค้า",
    seeProfit: "กำไร See (บาท)",
    seeProfitRatio: "สัดส่วนกำไรจากการขาย See",
    sorProfit: "กำไร Sor (บาท)",
    sorProfitRatio: "สัดส่วนกำไรจากการขาย Sor",
  };
  const numericCell = (
    field,
    tone = "teal",
    showEditIcon = false,
    suffix = "",
    valueColor,
    subLabel,
  ) => ({
    field,
    type: "number",
    width: 145,
    sortable: false,
    align: "right",
    headerAlign: "center",
    headerClassName: `${tone}Header`,
    renderHeader: () => header(columnLabels[field]),
    renderCell: ({ value, row }) => (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          pr: 1,
          color:
            typeof valueColor === "function"
              ? valueColor(row)
              : valueColor,
        }}
      >
        {subLabel && (
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              lineHeight: 1,
              fontSize: "0.7rem",
              fontWeight: 700,
              whiteSpace: "nowrap",
            }}
          >
            {typeof subLabel === "function" ? subLabel(row) : subLabel}
          </Typography>
        )}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {value === null || value === undefined || value === ""
            ? "-"
            : `${formatNumber(value)}${suffix}`}
          {showEditIcon && (
            <EditOutlinedIcon
              fontSize="small"
              color="action"
              sx={{ fontSize: 16 }}
              titleAccess="แก้ไขได้"
            />
          )}
        </Box>
      </Box>
    ),
  });
  const columns = [
    { field: "productName", headerName: "ชื่อเป็นสินค้า", width: 180, headerClassName: "tealHeader", renderHeader: () => header("ชื่อเป็นสินค้า") },
    {
      field: "sellProduct", headerName: "ขายเป็นสินค้า", width: 220,
      headerClassName: "tealHeader", renderHeader: () => header("ขายเป็นสินค้า"),
      renderCell: ({ value, row }) => canEditSellProduct && row.status === "OPEN" ? (
        <Button
          size="small" endIcon={<EditOutlinedIcon />} sx={{ textTransform: "none" }}
          onClick={(event) => { event.stopPropagation(); setSellProductRow(row); }}
        >
          {value || "-"}{row.sellProductId ? " (Manual)" : ""}
        </Button>
      ) : `${value || "-"}${row.sellProductId ? " (Manual)" : ""}`,
    },
    { field: "purchaseQuantity", ...numericCell("purchaseQuantity"), renderHeader: () => header("จำนวนรับซื้อ") },
    {
      field: "lockWeightBalance",
      headerName: "น้ำหนักขายจริง/น้ำหนัก Lock",
      width: 200,
      headerClassName: "tealHeader",
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderHeader: () => header("น้ำหนักขายจริง/น้ำหนัก Lock (กก.)"),
      valueGetter: (_, row) => {
        const weight = row.weight;
        const remainingWeight = row.remainingWeight ?? weight;
        const soldWeight = weight == null
          ? null
          : Math.max(0, Number(weight) - Number(remainingWeight));
        return `${soldWeight == null ? "-" : formatNumber(soldWeight)} / ${weight == null ? "-" : formatNumber(weight)}`;
      },
    },
    { field: "seeShopPrice", ...numericCell("seeShopPrice"), renderHeader: () => header("ราคาหน้าร้าน See") },
    { field: "sorShopPrice", ...numericCell("sorShopPrice"), renderHeader: () => header("ราคาหน้าร้าน Sor") },
    { ...numericCell("seeContractProfit", "teal", true), editable: true },
    numericCell("costPrice", "teal"),
    {
      ...numericCell(
        "salePrice",
        "pink",
        true,
        "",
        (row) =>
          row.salePriceSource === "SO" || row.salePriceSource === "MANUAL"
            ? "text.primary"
            : "error.main",
        (row) => (row.salePriceSource === "MANUAL" ? "Manual" : "Auto"),
      ),
      editable: true,
    },
    numericCell(
      "stockQuota",
      "pink",
      false,
      "",
      (row) => (Number(row.stockQuota) < 0 ? "error.main" : "text.primary"),
    ),
    numericCell("remainingProfit", "pink"),
    { ...numericCell("incentive", "pink", true, "%"), editable: true },
    ...["specialRatio", "specialPrice", "sorPayAmount", "seeProfit"].map((field) => numericCell(field, "teal")),
    ...["seeProfitRatio", "sorProfit", "sorProfitRatio"].map((field) => numericCell(field, "pink")),
    {
      field: "recordDate",
      width: 170,
      headerName: "วันที่ล็อคราคา",
      headerClassName: "tealHeader",
      renderHeader: () => header("วันที่ล็อคราคา"),
      renderCell: ({ value }) =>
        value ? moment(value).add(543, "year").format("D MMM YYYY") : "-",
    },
    {
      field: "status",
      width: 110,
      headerName: "สถานะ",
      headerClassName: "tealHeader",
      headerAlign: "center",
      align: "center",
      renderHeader: () => header("สถานะ"),
      renderCell: ({ value }) => {
        const statusSx = {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          fontWeight: 700,
        };

        if (value === "OPEN") {
          return (
            <Typography variant="body2" color="success.main" sx={statusSx}>
              ใช้งานได้
            </Typography>
          );
        }
        if (value === "CLOSED") {
          return (
            <Typography variant="body2" color="error" sx={statusSx}>
              สิ้นสุด
            </Typography>
          );
        }
        if (value === "CANCELLED") return <BlockIcon style={{ color: "orange" }} />;
        return "-";
      },
    },
    {
      field: "actions",
      width: 130,
      headerName: "จัดการ",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerClassName: "tealHeader",
      headerAlign: "center",
      align: "center",
      renderHeader: () => header("จัดการ"),
      renderCell: ({ row }) =>
        row.status === "OPEN" ? (
          <Button
            size="small"
            color="error"
            variant="outlined"
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              void handleCloseLockPricing(row);
            }}
          >
            สิ้นสุด
          </Button>
        ) : (
          "-"
        ),
    },
  ];
  const visibleColumns = columns.filter(
    (column) =>
      (column.field !== "actions" || currentBranch?.branchCode === "B01") &&
      (showPinkColumns || column.headerClassName !== "pinkHeader"),
  );
  const masterColumns = [
    {
      field: "recordDate",
      flex: 1,
      minWidth: 180,
      headerName: "วันที่",
      headerClassName: "tealHeader",
      renderHeader: () => header("วันที่"),
      renderCell: ({ value }) =>
        value ? moment(value).add(543, "year").format("D MMM YYYY") : "-",
    },
    {
      field: "itemCount",
      flex: 1,
      minWidth: 180,
      type: "number",
      headerName: "จำนวนรายการ",
      headerClassName: "tealHeader",
      headerAlign: "center",
      align: "right",
      renderHeader: () => header("จำนวนรายการ"),
      renderCell: ({ value }) => (
        <Box sx={{ width: "100%", textAlign: "right", pr: 1 }}>
          {Number(value || 0).toLocaleString("th-TH", {
            maximumFractionDigits: 0,
          })}
        </Box>
      ),
    },
    {
      field: "status",
      flex: 1,
      minWidth: 180,
      headerName: "สถานะ",
      headerClassName: "tealHeader",
      headerAlign: "center",
      align: "center",
      renderHeader: () => header("สถานะ"),
      renderCell: ({ value }) =>
        value === "APPROVED"
          ? "ส่ง Stock แล้ว"
          : value === "DRAFT"
            ? "ยังไม่ส่ง Stock"
            : "-",
    },
    {
      field: "actions",
      flex: 1,
      minWidth: 180,
      headerName: "รายละเอียด",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerClassName: "tealHeader",
      renderHeader: () => header("รายละเอียด"),
      renderCell: ({ row }) => (
        <Button
          size="small"
          variant="outlined"
          onClick={(event) => {
            event.stopPropagation();
            openMasterDetail(row);
          }}
        >
          ดูรายละเอียด
        </Button>
      ),
    },
    {
      field: "stockAction",
      flex: 1,
      minWidth: 180,
      headerName: "Action",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerClassName: "tealHeader",
      headerAlign: "center",
      align: "center",
      renderHeader: () => header("Action"),
      renderCell: ({ row }) =>
        row.status === "DRAFT" ? (
          <Button
            size="small"
            variant="contained"
            color="success"
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setStockTargetStatus("APPROVED");
              setStockConfirmMaster(row);
            }}
          >
            ส่ง Stock
          </Button>
        ) : row.status === "APPROVED" ? (
          currentBranchCode === "B01" ? (
            <Button
              size="small"
              variant="outlined"
              color="error"
              onMouseDown={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setStockTargetStatus("DRAFT");
                setStockConfirmMaster(row);
              }}
            >
              ยกเลิก
            </Button>
          ) : (
            <Typography
              color="success.main"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                fontWeight: 700,
              }}
            >
              ส่ง Stock แล้ว
            </Typography>
          )
        ) : (
          "-"
        ),
    },
  ];
  const openMasterDetail = (row) => {
    const params = new URLSearchParams({ masterId: String(row.id) });
    if (selectedUserId) params.set("customerId", String(selectedUserId));
    window.open(
      `${window.location.origin}/lock_pricing?${params.toString()}`,
      "_blank",
      "noopener,noreferrer",
    );
  };
  const handleMasterStatusConfirm = async () => {
    const masterId = Number(stockConfirmMaster?.id);
    if (!masterId || approvingMaster) return;

    setApprovingMaster(true);
    try {
      await services.updateLockPricingMasterStatus(masterId, stockTargetStatus);
      setMasters((previous) =>
        previous.map((master) =>
          Number(master.id) === masterId
            ? { ...master, status: stockTargetStatus }
            : master,
        ),
      );
      setStockConfirmMaster(null);
      toast.success(
        stockTargetStatus === "APPROVED"
          ? "ส่ง Stock เรียบร้อยแล้ว"
          : "ยกเลิกการส่ง Stock เรียบร้อยแล้ว",
      );
    } catch (error) {
      console.error("เปลี่ยนสถานะรายการประกันราคาไม่สำเร็จ:", error);
      toast.error("ไม่สามารถเปลี่ยนสถานะรายการประกันราคาได้");
    } finally {
      setApprovingMaster(false);
    }
  };
  const handleCloseLockPricing = async (row) => {
    const lockPricingId = Number(row?.id);
    if (!lockPricingId) {
      toast.error("ไม่พบรายการประกันราคาที่ต้องการสิ้นสุด");
      return;
    }

    try {
      await services.closeLockPricing(lockPricingId);
      // รอให้ DataGrid จบ click event ก่อนนำแถวออกจากตัวกรอง OPEN
      setTimeout(() => {
        setProducts((previous) =>
          previous.map((item) =>
            item.id === lockPricingId
              ? { ...item, status: "CLOSED", remainingWeight: 0 }
              : item,
          ),
        );
      }, 0);
      toast.success("สิ้นสุดรายการประกันราคาแล้ว");
    } catch (error) {
      console.error("ปิดรายการประกันราคาไม่สำเร็จ:", error);
      toast.error("ไม่สามารถสิ้นสุดรายการประกันราคาได้");
    }
  };
  const selectedDateTitle = startDate
    ? moment(startDate).add(543, "year").format("D MMMM YYYY")
    : "";
  const selectedMaster = masters.find(
    (master) => Number(master.id) === Number(selectedMasterId),
  );
  const filteredMasters = masters.filter(
    (master) => {
      if (onlyApprovedMasters && master.status !== "APPROVED") return false;
      if (masterStatus !== "all" && master.status !== masterStatus) return false;
      if (startDate) {
        if (!master.recordDate) return false;
        if (moment(master.recordDate).format("YYYY-MM-DD") !== startDate) return false;
      }
      return true;
    },
  );

  return (
    <Box p={2}>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" reverseOrder={false} />
      <SellProductDialog
        row={sellProductRow}
        onClose={() => setSellProductRow(null)}
        onSaved={() => {
          setSellProductRow(null);
          setRefreshVersion((value) => value + 1);
          toast.success("บันทึกสินค้าที่ขายเรียบร้อยแล้ว");
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          my: 2,
        }}
      >
        <Typography component="h2" variant="h5">
          การล็อกราคาสินค้า
          {isDetailPage && selectedDateTitle ? ` วันที่ ${selectedDateTitle}` : ""}
        </Typography>
        {isDetailPage &&
          currentBranch?.branchCode &&
          currentBranch.branchCode !== "B01" &&
          selectedMaster && (
            <Button
              color="success"
              variant="contained"
              disabled={
                loadingMasters || approvingMaster || selectedMaster.status !== "DRAFT"
              }
              onClick={() => {
                setStockTargetStatus("APPROVED");
                setStockConfirmMaster(selectedMaster);
              }}
              sx={{ flexShrink: 0, ml: 2 }}
            >
              {selectedMaster.status === "APPROVED" ? "ส่ง Stock แล้ว" : "ส่ง Stock"}
            </Button>
          )}
      </Box>
      <Grid container spacing={2} sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
        {canSelectBranchCustomers && !isDetailPage && (
          <Grid
            item
            xs={12}
            md={1.8}
            sx={{
              minWidth: 0,
              boxSizing: "border-box",
              flex: { md: "0 0 15%" },
              maxWidth: { md: "15%" },
            }}
          >
            <Paper
              variant="outlined"
              sx={{ mt: 2, maxHeight: 600, overflow: "auto" }}
            >
              <Typography
                sx={{
                  px: 2,
                  py: 1.5,
                  fontWeight: 800,
                  color: "text.primary",
                  borderBottom: "1px solid #eee",
                }}
              >
                เลือกสาขา
              </Typography>
              {loadingUsers ? (
                <Typography sx={{ p: 2 }} color="text.secondary">
                  กำลังโหลดรายชื่อลูกค้า...
                </Typography>
              ) : customers.length === 0 ? (
                <Typography sx={{ p: 2 }} color="text.secondary">
                  ไม่พบลูกค้าประเภทสาขา
                </Typography>
              ) : (
                customers.map((user) => {
                    const isSelected = selectedUserId === user.id;

                    return (
                      <Box
                        key={user.id}
                        onClick={() => {
                          setSelectedUserId(user.id);
                          setSelectedMasterId(null);
                          setStartDate("");
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          px: 2,
                          py: 1,
                          borderBottom: "1px solid #eee",
                          cursor: "pointer",
                          backgroundColor: isSelected ? "grey.100" : "transparent",
                          border: isSelected ? "grey.100" : "transparent",
                          borderRadius: 1,
                          transition: "0.2s",
                        }}
                      >
                        <Avatar src={user.img} sx={{ width: 50, height: 50, mr: 1 }}>
                          {!user.img && <NoPhotographyOutlinedIcon fontSize="large" />}
                        </Avatar>
                        <Box sx={{ flex: 1 }}>
                          <Typography>{user.name}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            {user.personType === "corporate" ? "นิติบุคคล" : "บุคคลธรรมดา"}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })
              )}
            </Paper>
          </Grid>
        )}

        {/* RIGHT COLUMN - Products */}
        <Grid
          item
          xs={12}
          md={canSelectBranchCustomers && !isDetailPage ? 10.2 : 12}
          sx={{
            minWidth: 0,
            width: { md: 0 },
            flex: { md: "1 1 0%" },
            maxWidth: { md: "none" },
            overflow: "hidden",
          }}
        >
          {/* <TextField
            fullWidth
            placeholder="ค้นหาด้วยชื่อสินค้า หรือหมวดหมู่หลัก"
            value={productSearch}
            onChange={(e) => setProductSearch(e.target.value)}
            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
          /> */}
          {!isDetailPage && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
              flexWrap="wrap"
              gap={2}
            >
              {!onlyApprovedMasters && (
                <ButtonGroup variant="outlined" color="success" size="small">
                <Button
                  variant={masterStatus === "all" ? "contained" : "outlined"}
                  onClick={() => setMasterStatus("all")}
                >
                  ทั้งหมด
                </Button>
                <Button
                  variant={masterStatus === "DRAFT" ? "contained" : "outlined"}
                  onClick={() => setMasterStatus("DRAFT")}
                >
                  ยังไม่ส่ง Stock
                </Button>
                <Button
                  variant={masterStatus === "APPROVED" ? "contained" : "outlined"}
                  onClick={() => setMasterStatus("APPROVED")}
                >
                  ส่ง Stock แล้ว
                </Button>
                </ButtonGroup>
              )}
              <TextField
                label="วันที่"
                type="date"
                value={startDate || ""}
                onChange={(event) => setStartDate(event.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          )}
          {!isDetailPage && (
            <>
              <Typography sx={{ mt: 3, mb: 1, fontWeight: 700, textAlign: "center" }}>
                รายการประกันราคารายวัน
              </Typography>
            </>
          )}
          {!isDetailPage && <Box sx={{ width: "100%", maxWidth: "100%", mx: "auto", minWidth: 0, overflow: "hidden" }}>
            {loadingMasters ? (
              <Typography color="text.secondary" sx={{ py: 2 }}>
                กำลังโหลดรายการประกันราคารายวัน...
              </Typography>
            ) : filteredMasters.length === 0 ? (
              <Typography color="text.secondary" sx={{ py: 2 }}>
                ไม่พบรายการประกันราคา
              </Typography>
            ) : (
              <DataGrid
                rows={filteredMasters}
                columns={masterColumns}
                autoHeight
                hideFooter
                disableRowSelectionOnClick
                sx={{
                  width: "100%",
                  minWidth: 0,
                  "& .MuiDataGrid-columnHeaders": { minHeight: 56 },
                  "& .MuiDataGrid-columnHeader": { whiteSpace: "normal" },
                  "& .tealHeader": { backgroundColor: "#c6dad7" },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    whiteSpace: "normal",
                    lineHeight: 1.15,
                    textAlign: "center",
                  },
                }}
              />
            )}
          </Box>}
          {isDetailPage && selectedMasterId ? (
            <>
              <Box
                sx={{
                  mt: 3,
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Typography sx={{ fontWeight: 700 }}>
                  รายละเอียด LockPricing
                  {!showManualRows ? " (รายการรับซื้อจริง)" : " (รวมรายการ Manual)"}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    checked={showManualRows}
                    onChange={(event) => setShowManualRows(event.target.checked)}
                    size="small"
                  />
                  <Typography variant="body2">แสดงรายการแปลงสินค้า Manual</Typography>
                </Box>
              </Box>
              <Box sx={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
                <DataGrid
                  rows={filteredProducts}
                  columns={visibleColumns}
                  slots={{ footer: LockPricingFooter }}
                  autoHeight
                  getRowHeight={() => 58}
                  disableRowSelectionOnClick
                  processRowUpdate={processRowUpdate}
                  isCellEditable={({ row }) => row.status !== "CLOSED"}
                  onProcessRowUpdateError={(error) => {
                    if (error?.message) toast.error(error.message);
                  }}
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    "& .MuiDataGrid-columnHeaders": { minHeight: 72 },
                    "& .MuiDataGrid-columnHeader": { whiteSpace: "normal" },
                    "& .tealHeader": { backgroundColor: "#c6dad7" },
                    "& .pinkHeader": { backgroundColor: "#ec00f4" },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      whiteSpace: "normal",
                      lineHeight: 1.15,
                      textAlign: "center",
                    },
                  }}
                />
              </Box>
            </>
          ) : isDetailPage ? (
            <Typography color="text.secondary" sx={{ py: 3 }}>
              ไม่พบข้อมูลรายละเอียด LockPricing ของวันที่เลือก
            </Typography>
          ) : null}
        </Grid>
      </Grid>
      <Dialog
        open={Boolean(stockConfirmMaster)}
        onClose={() => {
          if (!approvingMaster) setStockConfirmMaster(null);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          {stockTargetStatus === "DRAFT"
            ? "ยืนยันยกเลิกการส่ง Stock"
            : "ยืนยันการส่ง Stock"}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {stockTargetStatus === "DRAFT"
              ? "ยืนยันยกเลิกการส่ง Stock รายการประกันราคาวันที่"
              : "ยืนยันส่ง Stock รายการประกันราคาวันที่"}{" "}
            {stockConfirmMaster?.recordDate
              ? moment(stockConfirmMaster.recordDate)
                  .add(543, "year")
                  .format("D MMM YYYY")
              : "-"}
            {" "}ใช่หรือไม่?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setStockConfirmMaster(null)}
            disabled={approvingMaster}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleMasterStatusConfirm}
            variant="contained"
            color={stockTargetStatus === "DRAFT" ? "error" : "success"}
            disabled={approvingMaster}
          >
            {approvingMaster
              ? stockTargetStatus === "DRAFT"
                ? "กำลังยกเลิก..."
                : "กำลังส่ง Stock..."
              : stockTargetStatus === "DRAFT"
                ? "ยืนยันยกเลิก"
                : "ยืนยัน Stock"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GroupPricingPage;
